import ReactiveComponent, { watch } from '../utils/reactive-component';
import AjaxLoader from './ajax-loader/ajax-loader';
import cartStore from '@stores/cart/cart-store';

const BS_CLASS_NAME_POSITION_ABSOLUTE = 'position-absolute';
const BS_CLASS_NAME_POSITION_RELATIVE = 'position-relative';
const BS_CLASS_NAME_WIDTH_FULL = 'w-100';

const CLASS_NAME_OPACITY_0 = 'opacity-0';

const DEFAULT_OPTIONS = {
    autoshipFrequency: 0,
    loaderLight: false,
    quantity: 1,
    showLoader: true,
    isRefill: false
};

export default class AddToCart extends ReactiveComponent {
    constructor($el, productId, variantId, options = {}, petId) {
        super();

        options = { ...DEFAULT_OPTIONS, ...options };
        Object.assign(this, options);

        this.$el = $el;
        this.$content = $(); // empty until assigned
        this.$loader = $(); // empty until assigned

        this.productId = productId;
        this.variantId = variantId;
        this.petId = petId;

        this.loader = null;

        this.reactive({
            loading: false
        });

        this.init();
    }

    [watch]() {
        return {
            loading(loading) {
                if(this.showLoader) {
                    if(!this.loader) this.setupLoader();

                    this.loader.active = loading;

                    if(loading) {
                        this.$content.addClass(CLASS_NAME_OPACITY_0);
                    } else {
                        this.$content.removeClass(CLASS_NAME_OPACITY_0);
                    }
                }
            }
        }
    }

    init() {
        this.setupListeners();
        this.setupLoaderMarkup();
    }

    async addToCart() {
        if(!this.productId || !this.variantId) {
            throw new Error('Both ProductId and VariantId are required to add a product to the cart');
        }

        this.loading = true;

        const { success, error } = await cartStore.actions.addLine(this.productId, this.variantId, {
            autoshipFrequency: this.autoshipFrequency,
            quantity: this.quantity,
            IsRefill:  this.isRefill
        },this.petId);

        if(success) {
            cartStore.actions.focusMiniCart({
                productId: this.productId,
                variantId: this.variantId,
                petId: this.petId
            });
        } else {
            console.error(error);
        }

        this.loading = false;
    }

    setupListeners() {
        this.$el.on('click', () => this.addToCart());
    }

    setupLoader() {
        if(this.showLoader) {
            this.loader = new AjaxLoader(this.$loader, {
                light: this.loaderLight,
                replaceOriginEl: false,
                size: 'xs',
                visible: true
            });
        }
    }

    setupLoaderMarkup() {
        if(this.showLoader) {
            const $container = $('<div></div>').addClass(BS_CLASS_NAME_POSITION_RELATIVE);
            this.$loader = $('<div></div>').addClass([BS_CLASS_NAME_POSITION_ABSOLUTE, BS_CLASS_NAME_WIDTH_FULL]);
            this.$content = $('<div></div>').html(this.$el.html());

            $container.append([ this.$loader, this.$content ]);
            this.$el.html($container);
        }
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-add-to-cart');
    rootEls?.forEach((el) => {
        const $el = $(el);

        const autoshipFrequency = $el.data('autoship-frequency') || 0;
        const productId  = $el.data('product-id') || null;
        const loaderLight = typeof $el.data('loader-light') === 'boolean' ? $el.data('loader-light') : false;
        const quantity = $el.data('quantity') || 1;
        const showLoader = typeof $el.data('loader') === 'boolean' ? $el.data('loader') : true;
        const variantId = $el.data('variant-id') || null;
        const petId = $el.data('pet-id') || null;
        const isRefill = typeof $el.data('isrefill') === 'boolean' ? $el.data('isrefill') : false;

        new AddToCart($el, productId, variantId, { 
            autoshipFrequency,
            loaderLight,
            quantity,
            showLoader,
            isRefill
        }, petId);
    });
});
